export const DEBUG_FORM = false;
export const __prod__ = process.env.NODE_ENV === 'production';
export const COOKIES_KEY = '_token';
export const BACKEND_BASE_URL = __prod__
  ? 'https://maven-note-app.herokuapp.com/api'
  : 'http://127.0.0.1:8000/api';
export const GOOGLE_AUTH_URL = BACKEND_BASE_URL + '/google';
